import { Component, Inject } from '@angular/core';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AlertService } from './services/alert.service';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { UtilService } from './services/util.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Yellow Folder';

  isAuthenticated = false;

  constructor(
    @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth,
    public authService: OktaAuthStateService,
    public yfAuth: AuthService,
    private readonly api: ApiService,
    private readonly alertService: AlertService,
    public util: UtilService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.authService.authState$.subscribe(
      (authObj) => {
        if (this.isAuthenticated) {
          return;
        }

        if (authObj.accessToken?.claims.sub) {
          this.api
            .authenticateOkta(
              '' + authObj.accessToken?.claims.sub,
              '' + authObj.accessToken?.claims.uid,
              '' + authObj.accessToken?.accessToken
            )
            .subscribe(
              (res) => {
                this.yfAuth.saveUser(res);
                this.isAuthenticated = true; // Set the flag to true after successful authentication
              },
              (err) => {
                this.alertService.toast(err.message);
                alert('User failed to log in with Yellowfolder');
                this.logout();
              }
            );
        }
      },
      (error) => {
        this.alertService.toast(error.message);
        alert('User failed to log in with Yellowfolder-Okta');
        this.logout();
      }
    );
  }

  async login() {
    await this.oktaAuth.signInWithRedirect();
  }

  async logout() {
    try {
      await this.oktaAuth.revokeAccessToken();
      await this.oktaAuth.revokeRefreshToken();
      this.oktaAuth.closeSession();
      await this.oktaAuth.tokenManager.clear();
      await this.oktaAuth.signOut();
      this.yfAuth.logout();
      localStorage.clear();
    } catch (error) {}
  }
}
